import React, {useState, useRef, useEffect, useCallback, useMemo} from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button1 from "../../UI/Button1";
import '../RichTextFieldComponent.css'; // Import your custom CSS
import { useNavigate, useParams } from 'react-router-dom';
import { API_ENDPOINTS } from "../../config";
import fetch from 'node-fetch';
import ImageUploadComponent from "../../CustomerLogosPage/components/ImageUploadComponent";
import { IMGTYPES } from "../../imgUploadConfig";
import "./quillVideoStyle.css";

// Register custom fonts
const Font = Quill.import('formats/font');
Font.whitelist = ['roboto'];
Quill.register(Font, true);


const NewBlogComponent = () => {
    const navigate = useNavigate();
    const quillRef = useRef(null);  // Reference to Quill instance
    const [content, setContent] = useState('');
    const [title, setTitle] = useState('');
    const [slug, setSlug] = useState('');

    const [isPosting, setIsPosting] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [isUploadingVideo, setIsUploadingVideo] = useState(false);

    const [image, setImage] = useState('');
    const [hasParams, SetHasParams] = useState(false);

    const { id, lang, duplicate } = useParams();
    
    // Customize the color palette
    const Color = Quill.import('formats/color');
    Color.whitelist = ['#6f9c21', '#333'];
    Quill.register(Color, true);

    useEffect(() => {
        console.log("Use Effect!")
        if (id) {
            SetHasParams(true);
            console.log("UseEffect, ID => ", id);
            fetchExistingBlog();
            console.log("Loaded with ID param: ", id, "lan param: ", lang);

            if (duplicate) {
                console.log("Setting Has Params to false due to duplicate");
                SetHasParams(false);
            }

        } else {
            SetHasParams(false);
            console.log("No ID param found.");
        }
    }, [id, lang, duplicate]);

    const imageUploader = async (file) => {
        const formData = new FormData();
        const token = localStorage.getItem('token');

        formData.append('image', file);

        const imgType = {
            width: 1920,
            height: 1080,
            fit: 'cover',
        };

        formData.append('IMGTYPE', JSON.stringify(imgType));

        const response = await fetch(`${API_ENDPOINTS.uploadImage}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });

        if (!response.ok) {
            throw new Error('Image upload failed');
        }

        const data = await response.json();
        console.log("Data from Image Uploader returns", data);

        return data.imageUrl;
    };

    const titleImageUpload = (imgUrl) => {
        console.log("Uploaded Title Image", imgUrl);
        setImage(imgUrl);
    };

    const imageHandler = useCallback(() => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            try {
                const url = await imageUploader(file);
                const range = quillRef.current.getEditor().getSelection();

                console.log("Success Image Upload with URl:", url);

                if (range) {
                    const imageEmbed = `<img src="${url}" class="quill-image-embed" alt="Uploaded Image" />`;
                    quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(range.index, imageEmbed);
                } else {
                    console.error('Range is null');
                }
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        };
    }, [imageUploader]);

    const parseQuillContent = () => {
        const delta = quillRef.current.getEditor().getContents();
        return quillRef.current.getEditor().root.innerHTML;
    };

    const videoHandler = useCallback(() => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'video/*');
        input.click();

        input.onchange = async () => {
            setIsUploadingVideo(true);
            console.log("IsUploading video =>", isUploadingVideo);

            const file = input.files[0];

            const formData = new FormData();
            formData.append('video', file);

            const token = localStorage.getItem('token');
            const uploadURL = API_ENDPOINTS.uploadVideo;

            const options = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            };

            if (file) {
                try {
                    const response = await fetch(uploadURL, options);

                    if (!response.ok) {
                        throw new Error('Video upload failed');
                    }

                    const data = await response.json();
                    const url = data.videoUrl;

                    console.log("Returned URL for video upload =>", url);

                    const range = quillRef.current.getEditor().getSelection();

                    if (range) {
                        const videoEmbed = `<iframe class="quill-video-embed" src="${url}" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>`;

                        quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(range.index, videoEmbed);
                    } else {
                        console.error('Range is null');
                    }
                } catch (e) {
                    console.error('Error uploading video:', e);
                }
            }

            setIsUploadingVideo(false);
        };
    }, [quillRef]);

    const modules = useMemo(() =>({
        toolbar: {
            container: [
                [{ 'header': '1' }, { 'header': '2' }],
                [{ 'size': [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image', 'video'],
                [{ 'align': [] }], // Add alignment options
                [{ 'color': Color.whitelist }, { 'background': [] }], // Add color and background options
                ['clean'],
            ],
            handlers: {
                'image': imageHandler,
                'video': videoHandler
            }
        }
    }),[]);

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', // Add align to formats
        'color', 'background' // Add color and background to formats
    ];

    const handleUpdate = async (event) => {
        event.preventDefault();

        console.log("Update, Handle ID =>", id);

        setIsPosting(true);

        const token = localStorage.getItem('token');

        const htmlContent = parseQuillContent();

        console.log("Handle Update, HTML Content => ", htmlContent);

        const formData = {
            title,
            slug: generateSlug(title),
            titleImg: image,
            htmlContent,
        };

        const options = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(formData)
        };

        console.log("Sending patch request", options);
        const updateUrl = `${API_ENDPOINTS.updateBlog}/${id}/${lang}`;

        try {
            console.log("PossibleURL:", `${API_ENDPOINTS.updateBlog}/${id}/${lang}`);
            const response = await fetch(updateUrl, options);

            if (response.ok) {
                navigate('/dashboard');
            } else {
                console.log("Update blog response not OK");
            }
        } catch (e) {
            console.log("Error patching to Webflow", e);
        } finally {
            setIsPosting(false);
        }
    };

    const handleSubmit = async (event, lan) => {
        event.preventDefault();
        setIsPosting(true);
        setIsFetching(true);

        const token = localStorage.getItem('token');

        console.log("Submitting blog with lan", lan);

        const htmlContent = parseQuillContent();

        console.log("HandleSubmit with HTML Content: ", htmlContent);

        const formData = {
            title,
            slug: generateSlug(slug),
            titleImg: image,
            htmlContent,
        };

        try {
            const response = await fetch(`${API_ENDPOINTS.postNewBlog}/${lan}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                navigate('/dashboard');
            } else {
                console.log("Response not OK");
            }
        } catch (error) {
            console.log('Error submitting blog:', error);
        } finally {
            setIsPosting(false);
            setIsFetching(false);
        }
    };

    const fetchExistingBlog = async () => {
        console.log("Start fetching existing blog");
        setIsFetching(true);

        const token = localStorage.getItem("token");
        try {
            const url = `${API_ENDPOINTS.getSingleBlog}/${id}/${lang}`;
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            };

            const req = await fetch(url, options);

            if (req.ok) {
                const fetchData = await req.json();
                console.log("fetchdata is", fetchData);

                setTitle(fetchData.fieldData.name);
                console.log("Setting title to", fetchData.fieldData.name);

                setSlug(fetchData.slug || '');
                setContent(fetchData.fieldData.content || '');
                setImage(fetchData.fieldData.titleimage ? fetchData.fieldData.titleimage.url : '');

            } else {
                console.log("Fetchdata from new blog component not ok");
            }

            console.log("Request was sent");

        } catch (e) {
            console.log("Error fetching existing blog:", e);
        } finally {
            setIsFetching(false);
        }
    };

    const generateSlug = (title) => {
        return title
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-_]/g, '')
            .replace(/-+/g, '-');
    };

    useEffect(() => {
        console.log("Component mounted");
        return () => {
            console.log("Component unmounted");
        };
    }, []);

    return (
        <div className="container mx-auto p-4 bg-white shadow-md rounded-md mt-5 mb-5">
            {isUploadingVideo && (
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-md shadow-lg">
                        <h2 className="text-lg font-semibold">Uploading video...</h2>
                    </div>
                </div>
            )}
            {isFetching ? (
                <div className="text-center py-10">
                    <h2 className="text-2xl font-semibold">Loading...</h2>
                </div>
            ) : (
                <form>
                    <div className="space-y-12 m-10">
                        <div className="border-b border-gray-900/10 pb-12">
                            <h1 className="text-2xl font-semibold leading-7 text-gray-900 mb-6">Create a new blog post</h1>
                            <div className="flex flex-col gap-4 mb-6">
                                <input
                                    type="text"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Title"
                                    className="border p-2 rounded-md w-full"
                                />
                                <div className="flex flex-col">
                                    <h2 className="text-lg font-medium mb-2">Set title image</h2>
                                    <ImageUploadComponent
                                        onImageUpload={titleImageUpload}
                                        IMGTYPE={IMGTYPES.jobAdImage}
                                        image={image}
                                        title={"Set title image"}
                                    />
                                </div>
                            </div>
                            <ReactQuill
                                ref={quillRef}
                                value={content}
                                onChange={setContent}
                                modules={modules}
                                formats={formats}
                                className="mb-4"
                            />
                        </div>
                    </div>
                    <div className="mt-6 flex items-center justify-center gap-x-6 mb-10">
                        {!hasParams && (
                            <div className="flex gap-5">
                                <Button1 onclick={(event) => handleSubmit(event, 'de')} text={"Publish Blog German"} type="button">
                                    Publish Blog German
                                </Button1>
                                <Button1 onclick={(event) => handleSubmit(event, 'en')} text={"Publish Blog English"} type="button">
                                    Publish Blog English
                                </Button1>
                            </div>
                        )}
                        {hasParams && (
                            <div>
                                <Button1 onclick={handleUpdate} text={"Update Blog"} type="button">
                                    Update Blog
                                </Button1>
                            </div>
                        )}
                    </div>
                </form>
            )}
        </div>
    );
};

export default NewBlogComponent;
